var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import React from 'react';
export const convertFlexHelperProps = (props) => {
    const styleObject = {};
    if (props.grow) {
        styleObject.flexGrow = props.grow;
    }
    if (props.shrink) {
        styleObject.flexShrink = props.shrink;
    }
    if (props.flex) {
        styleObject.flex = props.flex;
    }
    if (props.basis) {
        styleObject.flexBasis = props.basis;
    }
    if (props.centered) {
        styleObject.alignItems = 'center';
        styleObject.justifyContent = 'center';
    }
    if (props.align) {
        styleObject.alignItems = props.align;
    }
    if (props.justify) {
        styleObject.justifyContent = props.justify;
    }
    return styleObject;
};
export const Row = React.forwardRef((_a, ref) => {
    var { sx, children, breakpoint: breakpointParam } = _a, rest = __rest(_a, ["sx", "children", "breakpoint"]);
    const flexStyles = convertFlexHelperProps(rest);
    let flexDirection = 'row';
    if (breakpointParam !== undefined) {
        flexDirection = [];
        for (let i = 0; i <= breakpointParam; i++) {
            flexDirection.push('column');
        }
        flexDirection.push('row');
    }
    return (_jsx("div", Object.assign({}, rest, { ref: ref, sx: Object.assign(Object.assign(Object.assign({}, flexStyles), sx), { flexDirection, display: 'flex' }) }, { children: children })));
});
